module.exports = __webpack_public_path__ + "prize-5.fc3c6225.png";